module.exports = __webpack_public_path__ + "img/main-about.0b5157d3.png";